import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../Components/CSS/Global.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const pricingPlans = [
    { yearPlan: "₹1999", cut_off: "", duration: "1 Month", PerMonth: "For Trial", description: "" },
    { yearPlan: "₹14,099", cut_off: "₹23,988", duration: "1 Year", PerMonth: "41%", description: "" },
    { yearPlan: "₹19,790", cut_off: "₹47,976", duration: "2 Years", PerMonth: "59%", description: "" },
    { yearPlan: "₹24,108", cut_off: "₹71,964", duration: "3 Years", PerMonth: "66%", description: "", offer: "Best Offer" }
];


const PlanPricing = () => {
    const [activeTab, setActiveTab] = useState(0);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [PlanModal, setPlanModal] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        number: "",
        dob: "Website"
    });
    const [error, setError] = useState("");
    const [planselectedback, setPlanSelectBack] = useState({})
    const [loading, setLoading] = useState(false);
    const [isHumanChecked, setIsHumanChecked] = useState(false);
    const [agreedToTerms, setAgreedToTerms] = useState(false);
    const [checkboxErrors, setCheckboxErrors] = useState({
        isHuman: false,
        terms: false,
    });



    const handleChange = (e) => {
        const { name, value } = e.target;
        let updatedValue = value.trim(); // Remove leading and trailing spaces

        if (name === "number") {
            updatedValue = updatedValue.replace(/[^0-9]/g, '').slice(0, 10); // Allow only numbers and limit to 10 digits

            // Remove leading zero
            if (updatedValue.startsWith("0")) {
                updatedValue = updatedValue.slice(1);
            }
        }

        setFormData((prev) => ({
            ...prev,
            [name]: updatedValue,
        }));

        // Validation for phone number
        if (name === "number") {
            if (value.startsWith("0")) {
                setError("Phone number cannot start with 0");
            } else if (updatedValue.length < 10) {
                setError("Phone number must be 10 digits long");
            } else {
                setError("");
            }
        }

    };



    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleSelectPlan = (index, plan) => {
        setSelectedPlan(index);
        setPlanSelectBack(plan)
        console.log(plan)
    };

    const planSubmit = async (e) => {
        e.preventDefault();
        let plansend = planselectedback.yearPlan + " " + planselectedback.duration;
        if (!isHumanChecked || !agreedToTerms) {
            setCheckboxErrors({
                isHuman: !isHumanChecked,
                terms: !agreedToTerms,
            });
            return;
        }
        setLoading(true);

        try {
            const response = await fetch('https://100billionrealestate.com/inquiry', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    name: formData.name,
                    mobile: formData.number,
                    parent_name: '999/Month',
                    dob: plansend,
                    dob: "Website"
                }),
            });

            if (response.ok) {
                toast.success("Thank you! Our team will contact you soon.", {
                    position: "top-center",
                    autoClose: 3000, // Close toast after 3 seconds
                });

                setFormData({ name: '', number: '', dob: "Website" });
                setIsHumanChecked(false);
                setAgreedToTerms(false);
                // Close modal after 500ms
                setTimeout(() => {
                    setPlanModal(false); // Ensure `setShowModal` is correctly defined to control modal visibility
                }, 500);

            } else {
                toast.error("Please try again!", {
                    position: "top-center",
                    autoClose: 3000,
                });
            }
        } catch (error) {
            console.log(error);
            toast.error(`${error}`, {
                position: "top-center",
                autoClose: 3000,
            });
        } finally {
            setLoading(false);
        }
    };


    return (
        <>
            <div className="plan-pricing-hbt">
                <h1>Plan Pricing</h1>

                {/* Tabs for Mobile View */}
                {isMobile && (
                    <div className="pp-tabs-hbt">
                        {pricingPlans.map((plan, index) => (
                            <button
                                key={index}
                                className={`pp-tab-btn ${activeTab === index ? "active" : ""}`}
                                onClick={() => setActiveTab(index)}
                            >
                                {plan.duration}
                            </button>
                        ))}
                    </div>
                )}

                <div className="pp-cards-hbt">
                    {isMobile ? (
                        <AnimatePresence mode="wait">
                            <motion.div
                                key={activeTab}
                                className={`pp-card-hbt ${selectedPlan === activeTab ? "selected" : ""}`}
                                initial={{ opacity: 0, scale: 0.8 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 0.3 }}
                            >
                                <div className="ribbon">
                                    {activeTab === 0 ? (
                                        <span className="ribbon2"><div className='monthly-plan'>For<br />Trial</div></span>
                                    ) : (
                                        <span className="ribbon2">
                                            <div><span className='pp-per-month'></span>{pricingPlans[activeTab].PerMonth}</div>
                                            <div className='pp-per-month'>off</div>
                                        </span>
                                    )}
                                </div>

                                {pricingPlans[activeTab].offer && <p className="pp-card-best-offer">{pricingPlans[activeTab].offer}</p>}

                                <div className="pp-year-price-hbt">
                                    <h3>{pricingPlans[activeTab].yearPlan}</h3>
                                </div>
                                <div className={`${pricingPlans[activeTab].cut_off === "For Beginner" ? "pp-year-cutoffbeginner-hbt" : "pp-year-cutoffprice-hbt cut-off"}`}>
                                    <h3>{pricingPlans[activeTab].cut_off}</h3>
                                </div>
                                <div className="pp-duration-hbt">
                                    <h2>{pricingPlans[activeTab].duration}</h2>
                                </div>
                                <div className="pp-description-hbt">
                                    <p>{pricingPlans[activeTab].description}</p>
                                </div>
                                <div className="pp-btn-hbt">
                                    <button onClick={() => {
                                        handleSelectPlan(activeTab);
                                        setPlanModal(true);
                                    }}>
                                        {selectedPlan === activeTab ? "Selected" : "Select Plan"}
                                    </button>
                                </div>
                            </motion.div>
                        </AnimatePresence>
                    ) : (
                        pricingPlans.map((plan, index) => (
                            <motion.div
                                key={index}
                                className={`pp-card-hbt ${selectedPlan === index ? "selected" : ""}`}
                                whileHover={{ scale: 1.05 }}
                                transition={{ duration: 0.2 }}
                            >
                                <div className="ribbon">
                                    {index === 0 ? (
                                        <span className="ribbon2"><div className='monthly-plan'>For<br />Trial</div></span>
                                    ) : (
                                        <span className="ribbon2">
                                            <div><span className='pp-per-month'></span>{plan.PerMonth}</div>
                                            <div className='pp-per-month'>off</div>
                                        </span>
                                    )}
                                </div>

                                {plan.offer && <p className="pp-card-best-offer">{plan.offer}</p>}

                                <div className="pp-year-price-hbt">
                                    <h3>{plan.yearPlan}</h3>
                                </div>
                                <div className={`${plan.cut_off === "For Beginner" ? "pp-year-cutoffbeginner-hbt" : "pp-year-cutoffprice-hbt cut-off"}`}>
                                    <h3>{plan.cut_off}</h3>
                                </div>
                                <div className="pp-duration-hbt">
                                    <h2>{plan.duration}</h2>
                                </div>
                                <div className="pp-description-hbt">
                                    <p>{plan.description}</p>
                                </div>
                                <div className="pp-btn-hbt">
                                    <button onClick={() => {
                                        handleSelectPlan(index, plan);
                                        setPlanModal(true);
                                    }}>
                                        {selectedPlan === index ? "Selected" : "Select Plan"}
                                    </button>
                                </div>
                            </motion.div>
                        ))
                    )}
                </div>
            </div>

            {/* Popup Form */}
            {PlanModal && (
                <div className="popup-form-hbt">
                    <div className="popup-content-hbt">
                        <div className="popup-header-hbt">
                            <div className="popup-header-close-hbt" onClick={() => setPlanModal(false)}>
                                <i className="fa-solid fa-xmark desktop-close-hbt"></i>
                                <i className="fa-solid fa-arrow-left mobile-close-hbt"></i>
                            </div>
                            <h3>Get Started</h3>
                            <div></div>
                        </div>
                        <form onSubmit={planSubmit}>
                            <div className="form-field-hbt">
                                <label>Name</label>
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    placeholder="Enter your name"
                                />
                            </div>
                            <div className="form-field-hbt">
                                <label>Phone Number</label>
                                <input
                                    type="tel"
                                    name="number"
                                    value={formData.number}
                                    onChange={handleChange}
                                    required
                                    pattern="[0-9]{10}"
                                    placeholder="Enter 10 digit number"
                                    maxLength="10" // Restrict input length
                                />
                                {error && <p className="error-message-form">{error}</p>}
                            </div>
                            <div className="form-mainfieldcheck-hbt">
                                <div className="form-fieldcheck-hbt">
                                    <input
                                        type="checkbox"
                                        id="isHuman"
                                        checked={isHumanChecked}
                                        onChange={(e) => {
                                            setIsHumanChecked(e.target.checked);
                                            setCheckboxErrors((prev) => ({ ...prev, isHuman: false }));
                                        }}
                                    />

                                    <p className="form-terms-hbt">Please check the box to confirm you're human</p>



                                </div>
                                {checkboxErrors.isHuman && <p className="error-message-form">Please confirm you're human</p>}
                                <div className="form-fieldcheck-hbt">
                                    <input
                                        type="checkbox"
                                        id="terms"
                                        checked={agreedToTerms}
                                        onChange={(e) => {
                                            setAgreedToTerms(e.target.checked);
                                            setCheckboxErrors((prev) => ({ ...prev, terms: false }));
                                        }}
                                    />
                                    <p className="form-terms-hbt">By submitting, you agree to our <span onClick={() => window.open("https://100billiontech.com/terms-and-conditions", "_blank", "noopener,noreferrer")} style={{ cursor: "pointer", color: "#4685f6" }}>terms and conditions</span></p>


                                </div>
                                {checkboxErrors.terms && <p className="error-message-form">You must agree to the terms</p>}
                            </div>
                            <div className="form-actions-hbt">
                                <button type="submit" disabled={loading}>
                                    {loading ? (
                                        <div className="loader"></div> // Show loader while loading
                                    ) : (
                                        'Submit'
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </>
    );
};

export default PlanPricing;